<template>
<div>
	<div class="title">发票信息
		<RadioGroup v-model="form.invoiceType" class="ml15" @on-change="getInputInfo">
	        <Radio label="PLAIN" :disabled="disabled">普票（电子）</Radio>
	        <Radio label="VAT" :disabled="disabled">专票（纸质）</Radio>
	        <Radio label="NOT" :disabled="disabled">不开发票</Radio>
	    </RadioGroup>
	</div>
	<Form :model="form" :label-width="150" class="mt15" ref="invoice" :rules="invoiceValidate" v-if="form.invoiceType!='NOT'">
	    <FormItem label="公司名称" class="w600" prop="invoiceName" :rules="invoiceValidate.invoiceName">
			<Input type="text" v-model="form.invoiceName" placeholder="请输入公司名称" :maxlength="50"></Input>
	    </FormItem>
	    <FormItem label="统一社会信用代码" class="w600" prop="invoiceUniqueCode" :rules="invoiceValidate.invoiceUniqueCode">
			<Input type="text" v-model="form.invoiceUniqueCode" placeholder="请输入统一社会信用代码" :maxlength="50"></Input>
	    </FormItem>
		<FormItem label="开户地址" class="w600" prop="invoiceAddress" :rules="form.invoiceType == 'VAT'? invoiceValidate.invoiceAddress: [{ required: false }]">
			<Input type="text" v-model="form.invoiceAddress" placeholder="请输入开户地址" :maxlength="50"></Input>
		</FormItem>
		<FormItem label="联系电话" class="w600" prop="invoicePhone" :rules="form.invoiceType == 'VAT'? invoiceValidate.invoicePhone: [{ required: false }]">
			<Input type="text" v-model="form.invoicePhone"  placeholder="请输入联系电话" :maxlength="20"></Input>
		</FormItem>
		<FormItem label="开户行" class="w600" prop="openingBankName" :rules="form.invoiceType == 'VAT'? invoiceValidate.openingBankName: [{ required: false }]">
			<Input type="text" v-model="form.openingBankName" placeholder="请输入开户行" :maxlength="30"></Input>
		</FormItem>
		<FormItem label="对公账号" class="w600" prop="openingBankAccount" :rules="form.invoiceType == 'VAT'? invoiceValidate.openingBankAccount: [{ required: false }]">
			<Input type="text" v-model="form.openingBankAccount" placeholder="请输入对公账号" :maxlength="30" @on-blur="checkNum"></Input>
		</FormItem>
		<FormItem label="电子邮箱" class="w600" prop="invoiceDeliverEmail" :rules="form.invoiceType == 'VAT'? invoiceValidate.invoiceDeliverEmail: [{ required: false }]">
			<Input type="text"  v-model="form.invoiceDeliverEmail" placeholder="请输入电子邮箱" :maxlength="100"></Input>
		</FormItem>
		<FormItem label="邮寄地址" class="w600" prop="invoiceDeliverAddress" :rules="form.invoiceType == 'VAT'? invoiceValidate.invoiceDeliverAddress: [{ required: false }]">
			<Input type="text" v-model="form.invoiceDeliverAddress" placeholder="填写内容需要包含邮寄人姓名、电话与邮寄地址" :maxlength="100"></Input>
		</FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info:Object,
	},
	data () {
		return {
			form:{},
			invoiceValidate:{
				invoiceName:{required:true,message:'请输入开票名称',trigger:'blur'},
				// invoiceUniqueCode:{required:true,message:'请输入统一社会信用代码',trigger:'blur'},
				invoiceUniqueCode: [
					{required:true,message:'请输入统一社会信用代码',trigger:'blur'},
					{message:'统一社会信用代码格式错误',trigger:'blur',pattern:this.rules.organizationCode}
					// {message:'格式错误',trigger:'blur',pattern:this.rules.idNumber}
				],
				invoiceAddress:{required:true,message:'请输入开户地址',trigger:'blur'},
				invoicePhone:{required:true,message:'请输入联系电话',trigger:'blur'},
				openingBankName:{required:true,message:'请输入开户行',trigger:'blur'},
				openingBankAccount:{required:true,message:'请输入对公账号',trigger:'blur'},
				// openingBankAccount:[{required:true,message:'请输入对公账号',trigger:'blur',pattern:this.rules.publicAccount}],
				invoiceDeliverEmail:[
					{ required: true, message: '邮箱不能为空', trigger: 'blur' },
					{ type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
				],
				invoiceDeliverAddress:{required:true,message:'请输入邮寄地址',trigger:'blur'}
			},
			orderType:this.$route.query.orderType||'',
			isReset:this.$route.query.reset||'', // 是否重新投保
		}
	},
	computed:{
		disabled(){
			if (this.isReset) return false
			else return !this.form.invoiceName||!this.form.invoiceUniqueCode
		}
	},
	watch:{
		info (val) {
			this.form=val;
			this.form.invoiceName=val.subjectName||val.invoiceName||'';
			this.form.invoiceUniqueCode=val.idNumber||val.invoiceUniqueCode||'';
			this.$set(this.form,'invoiceType',val.invoiceType)
			if (val.invoiceType) {
				this.form.invoiceType = val.invoiceType.toString()
			} else {
				this.form.invoiceType='NOT'
			}
		},
	},
	created(){
		this.form=this.info
		this.$set(this.form,'invoiceType',this.info.invoiceType)
		if (this.form.invoiceType) {
			this.form.invoiceType = this.form.invoiceType.toString()
		} else {
			this.form.invoiceType='NOT'
		}
		this.form.invoiceName=this.info.subjectName||this.info.invoiceName||'';
		this.form.invoiceUniqueCode=this.info.idNumber||this.info.invoiceUniqueCode||'';
	},
	methods:{
		checkNum() {
			const reg = /^[0-9]\d{8,29}$/
			if (!reg.test(this.form.openingBankAccount)&&this.form.openingBankAccount) {
				this.$Message.warning('对公账号格式不正确')
				this.form.openingBankAccount = ''
			}
		},
		val () {
			return new Promise((resolve,reject)=>{
				if(this.form.invoiceType=='NOT'){
					resolve({
						invoiceType:'NOT'
					})
					return;
				} else if (this.form.invoiceType=='VAT'){
					this.$refs.invoice.validate(valid=>{
						resolve(valid?this.form:false)
					})
				} else {
					let reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if(this.form.invoiceDeliverEmail&&(this.form.invoiceDeliverEmail!==''&&!reg.test(this.form.invoiceDeliverEmail))){ 
						this.$Message.error('请输入有效的邮箱');
						return
					}
					this.$refs.invoice.validate(valid=>{
						resolve(valid?this.form:false)
					})
					resolve(this.form)
				}
			})
		},
		// 草稿箱
		drafts(){
			return new Promise ((resolve,rejct)=>{
				if(this.form.invoiceType=='NOT'){
					resolve({
						invoiceType:'NOT'
					})
					return;
				}
				resolve(this.form)
			})
		},
		/*获取用户输入的信息*/
		getInputInfo (value) {
			this.$set(this.form,'invoiceType',value)
			if(value=='NOT')return;
			this.$set(this.form,'invoiceAddress',this.form.invoiceAddress || this.form.address)
			this.$set(this.form,'invoicePhone',this.form.invoicePhone || this.form.contactPhone)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/Invoice.vue